<template>
  <div id="list-client-portal">
    <v-card>
      <v-card-title>
        <span>Portails |</span>
        <v-skeleton-loader
          type="card-heading"
          v-if="nbResults < 0 || global.totalPortals < 0"
        ></v-skeleton-loader>
        <span v-else class="ml-1 text-body-1">
          {{ nbResults }} / {{ global.totalPortals }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          v-if="isGrantedUser()"
          color="primary"
          icon
          @click.stop="createClientPortalDialog = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <create-client-portal-dialog
          v-if="createClientPortalDialog && isGrantedUser()"
          :open.sync="createClientPortalDialog"
        />
      </v-card-title>
      <v-divider></v-divider>
      <filtres-client-portal
        :criteria.sync="criteriaClientPortal"
      ></filtres-client-portal>
      <v-divider></v-divider>
      <v-card-text>
        <div id="table-portails-container">
          <client-portal-datatable
            :filter-params="criteriaClientPortal"
            v-on:display:nb-portails="updateNbResults"
          ></client-portal-datatable>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import CreateClientPortalDialog from "@/components/ClientPortal/CreateClientPortalDialog";
import ClientPortalDatatable from "@/components/ClientPortal/ClientPortalDatatable";
import FiltresClientPortal from "@/components/ClientPortal/FiltresClientPortal";
import { useTitle } from "@/composables/title";
import { useClientPortal } from "@/composables/client-portal";
import { toRefs, ref } from "@vue/composition-api";
import global from "@/composables/global";
import { useRoles } from "../composables/roles";

export default {
  components: {
    ClientPortalDatatable,
    CreateClientPortalDialog,
    FiltresClientPortal,
  },
  setup() {
    /* Import des API */
    const { setTitle, setIcon } = useTitle();
    const { criteriaClientPortal, data } = useClientPortal();

    const { isGrantedUser } = useRoles();

    /* Actions */
    setTitle("Portails");
    setIcon("portails");
    criteriaClientPortal.value.group = 0;

    /* Variables */
    const nbResults = ref(-1);

    /* Méthodes */
    const updateNbResults = function (value) {
      nbResults.value = value;
    };

    return {
      criteriaClientPortal,
      ...toRefs(data),
      nbResults,
      updateNbResults,
      global,
      isGrantedUser,
    };
  },
};
</script>
